/**
 * replacement for the react table using
 * the css display classes 'table', 'table-row' and so on
 * instead of <table>, <tr>, ... for more flexibility
 */
import * as _ from "lodash";
import * as React from "react";
export function Table(props) {
    const classes = ["table", "xtable"].concat((props.className || "").split(" "));
    if (props.condensed === true) {
        classes.push("table-condensed");
    }
    if (props.hover === true) {
        classes.push("table-hover");
    }
    return (React.createElement("table", { style: { ...props.style }, className: classes.join(" ") }, props.children));
}
export function THead(props) {
    const classes = ["table-header", "xthead"].concat((props.className || "").split(" "));
    return (React.createElement("thead", { style: { ...props.style }, className: classes.join(" "), ref: props.domRef }, props.children));
}
export function TBody(props) {
    const classes = ["xtbody"].concat((props.className || "").split(" "));
    return (React.createElement("tbody", { style: { ...props.style }, className: classes.join(" "), ref: props.domRef }, props.children));
}
export class TH extends React.Component {
    render() {
        const { children, className, domRef, style } = this.props;
        const classes = ["table-header-cell", "xth"].concat((className || "").split(" "));
        return (React.createElement("th", { style: { ...style }, className: classes.join(" "), ref: domRef, ..._.omit(this.props, ["style", "className", "domRef"]) }, children));
    }
}
export function TR(props) {
    const { className, domRef } = props;
    const classes = ["xtr"].concat((className || "").split(" "));
    return (React.createElement("tr", { className: classes.join(" "), ref: domRef, ..._.omit(props, ["className", "domRef"]) }, props.children));
}
export function TD(props) {
    const classes = ["xtd"].concat((props.className || "").split(" "));
    return (React.createElement("td", { className: classes.join(" "), ..._.omit(props, ["className", "domRef"]), ref: props.domRef }, props.children));
}
